// Outlook (Microsoft 365) calendar on a Team directory card. All behavior
// lives in CalendarConnectBadge, shared with GoogleConnectBadge so the two can
// never drift apart (connect or reconnect, read-only state, and Disconnect on
// your own card).
import React from "react";
import CalendarConnectBadge from "./CalendarConnectBadge";

export default function OutlookConnectBadge(props) {
  return <CalendarConnectBadge {...props} provider="microsoft" label={props.label || "Outlook"} />;
}
